import { Component, OnInit, Inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { AboutUsContent } from "@app/util/about-us-content";
import { RolesSharedService } from "@app/feature/main/roles-shared/services/roles-shared.service";
import { Router } from "@angular/router";
import { BreadcrumService } from "@app/shared/services/breadcrum.service";
import * as _ from "lodash";

declare var $: any;

@Component({
  selector: "app-about-us",
  templateUrl: "./about-us.component.html",
  styleUrls: ["./about-us.component.css"]
})
export class AboutUsComponent implements OnInit {
  aboutContent =
    "Ecosystm is a new age Technology Research and Advisory Firm that brings together tech buyers, vendors and analysts into one integrated platform. The firm moves away from the highly inefficient business models of traditional research firms and instead focuses on data democratisation, with an emphasis on accessibility, transparency and autonomy. With technology becoming the number one source for innovation and differentiation, and global annual spending on technology due to exceed US$5 trillion by 2020, Ecosystm aims to enable all companies to harness the power of market data to make informed decisions. Offering data and research input, sourcing and subscription services, Ecosystm promises its users in-depth and relevant research by default.";
  public aboutDetail: any = {};
  public show = false;
  public selectedIndex: any = null;
  public selectedAdvisorIndex: any = null;
  public selectedCategoryIndex: any = null;
  public selectedIndexAdvisor: any = null;
  public businessDescription: string = "";
  public boardDescription: string = "";
  public advisorDescription: string = '';
  public topValue: number = 230;
  public analystData: any = [];
  public setMargin: number = 0;
  startPage : Number;
  paginationLimit:Number;
  aboutUsTotalDetails: any;
  teamTotalDetails: any;
  boardAdvisorsList: any;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private rolesSharedService: RolesSharedService,
    private breadcrumService:BreadcrumService,
    private router: Router
  ) {
    this.document.body.classList.add("inner-page");
    this.document.body.classList.remove("outer-page");
    // this.aboutDetail = AboutUsContent;
  }

  ngOnInit() {
    this.getAnalystList();
    setTimeout (() => {
      this.getAboutUsContent();
    }, 2000);
    // timeout added for fixing analysts are not showing on initial loading.
  }

  // togglePopover(index) {
  //   this.selectedIndex = index;
  //   this.businessDescription = this.aboutDetail.businessOperations[index].description;
  // }

  // togglePopoverClick(index, status) {
  //   if (status === "businessOperationsActive") {
  //     this.selectedIndex = index;
  //     this.calculateTop(this.selectedIndex);
  //     // this.show = !this.show;
  //     this.businessDescription = this.aboutDetail.businessOperations[
  //       index
  //     ].description;
  //     $(".business-operations-description").show();
  //   }
  //   if (status === "boardAdvisorActive") {
  //     // this.show = !this.show;
  //     this.selectedIndexAdvisor = index;
  //     this.calculateTopAdvisor(this.selectedIndexAdvisor);
  //     this.boardDescription = this.aboutDetail.boardAdvisors[index].description;
  //     this.addMargin();
  //     $(".board-advisor-description").show();
  //   }
  // }
  togglePopoverClick(index, individualDeatil, jIndex) {
      this.show = !this.show;
      this.selectedIndex = index;
      this.selectedCategoryIndex = jIndex;
      this.calculateDescriptionTop();

      // this.calculateTopAdvisor(this.selectedIndexAdvisor);
      this.boardDescription = individualDeatil.description;
      // this.addMargin();
      $(".board-advisor-description").show();
  }
  togglePopoverClickAdvisors(index, individualDeatil) {
    this.show = !this.show;
    // dont remove selectedIndex from here as we use the same calculateDescriptionTop() function for top value calculation
    // which in-turn uses selectedIndex for calculations.
    this.selectedAdvisorIndex = index;
    this.calculateAdvisorDescriptionTop();

    // this.calculateTopAdvisor(this.selectedIndexAdvisor);
    this.advisorDescription = individualDeatil.description;
    // this.addMargin();
    $(".board-advisor-description").show();
}
  addMargin() {
    this.setMargin = $(".board-wrapper .advisor-description-container").height();
    $(".board-wrapper").css("margin-bottom", this.setMargin);
  }
  closePopover() {
    this.selectedIndex = null;
    this.selectedCategoryIndex = null;
    this.boardDescription = null;
    $(".business-operations-description").hide();
  }
  closeMobilePopover() {
    this.selectedIndex = null;
    this.boardDescription = null;
    this.selectedCategoryIndex = null;
    $(".board-advisor-description-sm").hide();
  }
  closeAdvisorPopover() {
    this.selectedAdvisorIndex = null;
    this.advisorDescription = null;
    $(".board-advisor-description").hide();
  }
  closeAdvisorMobilePopover() {
    this.selectedAdvisorIndex = null;
    this.advisorDescription = null;
    $(".board-advisor-description-sm").hide();
  }
  // Business and Operations
  calculateTop(i) {
    const n = this.aboutDetail.businessOperations.length;
    // Extra Large Mointors
    if (screen.width >= 1200) {
      if (this.selectedIndex >= 4 && this.selectedIndex < 8) {
        this.topValue = 435;
      } else if (this.selectedIndex >= 8 && this.selectedIndex < 12) {
        this.topValue = 640;
      } else if (this.selectedIndex >= 12) {
        this.topValue = 835;
      } else {
        this.topValue = 230;
      }
    }
    //  Large Mointors
    if (screen.width >= 992 && screen.width < 1200) {
      if (this.selectedIndex >= 3 && this.selectedIndex < 6) {
        this.topValue = 420;
      } else if (this.selectedIndex >= 6 && this.selectedIndex < 9) {
        this.topValue = 615;
      } else if (this.selectedIndex >= 9) {
        this.topValue = 820;
      } else {
        this.topValue = 223;
      }
    }
    this.applyTop();
  }
  applyTop() {
    $(".description-container").css("top", this.topValue + "px");
  }

  // Board Advisors

  calculateTopAdvisor(j) {
    // Extra Large Mointors
    if (screen.width >= 1200) {
      if (this.selectedIndexAdvisor >= 4 && this.selectedIndexAdvisor < 8) {
        this.topValue = 435;
      } else if (
        this.selectedIndexAdvisor >= 8 &&
        this.selectedIndexAdvisor < 12
      ) {
        this.topValue = 640;
      } else if (this.selectedIndexAdvisor >= 12) {
        this.topValue = 835;
      } else {
        this.topValue = 230;
      }
    }
    //  Large Mointors
    if (screen.width >= 992 && screen.width < 1200) {
      if (this.selectedIndexAdvisor >= 3 && this.selectedIndexAdvisor < 6) {
        this.topValue = 420;
      } else if (
        this.selectedIndexAdvisor >= 6 &&
        this.selectedIndexAdvisor < 9
      ) {
        this.topValue = 615;
      } else if (this.selectedIndexAdvisor >= 9) {
        this.topValue = 820;
      } else {
        this.topValue = 223;
      }
    }
    this.applyTopAdvisor();
  }
  applyTopAdvisor() {
    $(".advisor-description-container").css("top", this.topValue + "px");
  }
  // Analyst
  getAnalystListFilter() {
    const filter: any = {};
    return filter;
  }

  getAnalystList() {
    this.rolesSharedService
      .getAnalystListDetails(this.getAnalystListFilter())
      .subscribe((data: any) => {
        this.analystData = data;
        this.startPage = 0;
        this.paginationLimit = 8;
      });
  }
  showMoreItems()
  {
     this.paginationLimit = Number(this.analystData.length);
     this.teamTotalDetails.cmsPost[this.teamTotalDetails.cmsPost.length - 1].cmsPostDetails = this.analystData;
  }
  showLessItems()
  {
    this.paginationLimit = 8;
    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView();
      top = null;
    }
    this.teamTotalDetails.cmsPost[this.teamTotalDetails.cmsPost.length - 1].cmsPostDetails = this.analystData.slice(0, 8);

  }
  analystClick(analystId: string,firstName,lastName) {
    this.breadcrumService.setUrl('BC3Label',  firstName + ' ' + lastName);

    this.router.navigate(["analyst-profile"], {
      queryParams: { analystId: analystId }
    });
  }
  // below code for future integration
  routeTechAnalystProfilePage(id:any){

  }
  getAboutUsContent() {
    let teamIndex;
    this.rolesSharedService.getWholeAboutUs().subscribe((response) => {
      this.aboutUsTotalDetails = response;
      this.teamTotalDetails = _.find(this.aboutUsTotalDetails, {'type': 'team_ecosystm'});
      this.boardAdvisorsList =  this.teamTotalDetails.cmsPost[this.teamTotalDetails.cmsPost.length - 1];
      this.teamTotalDetails.cmsPost[this.teamTotalDetails.cmsPost.length - 1] = {
        title: 'Analysts',
        type: 'analyst',
        cmsPostDetails: this.analystData.slice(0, 8)
      };
      teamIndex = _.findIndex(this.aboutUsTotalDetails, {'type': 'team_ecosystm'});
      this.aboutUsTotalDetails[teamIndex] = this.teamTotalDetails;
    });
  }

  calculateDescriptionTop() {
    // Extra Large Mointors
    if (screen.width >= 1200) {
      const s = Math.floor(this.selectedIndex / 4);
      const incrementPixels = 205;
      const totalIncrements = s * incrementPixels;
      this.topValue = 230 + totalIncrements;
    }
    //  Large Mointors
    if (screen.width >= 992 && screen.width < 1200) {
      const s = Math.floor(this.selectedIndex / 3);
      const incrementPixels = 205;
      const totalIncrements = s * incrementPixels;
      this.topValue = 220 + totalIncrements;
    }
    this.applyDescriptionTop();
  }
  calculateAdvisorDescriptionTop() {
    // Extra Large Mointors
    if (screen.width >= 1200) {
      const s = Math.floor(this.selectedAdvisorIndex / 4);
      const incrementPixels = 205;
      const totalIncrements = s * incrementPixels;
      this.topValue = 230 + totalIncrements;
    }
    //  Large Mointors
    if (screen.width >= 992 && screen.width < 1200) {
      const s = Math.floor(this.selectedAdvisorIndex / 3);
      const incrementPixels = 205;
      const totalIncrements = s * incrementPixels;
      this.topValue = 220 + totalIncrements;
    }
    this.applyDescriptionTop();
  }
  applyDescriptionTop() {
    $(".advisor-description-container").css("top", this.topValue + "px");
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/external/about-us/about-us.component.ts